import React from 'react';
import { SectionTitle } from './SectionTitle';

export interface ListItem {
  name: string;
  value: string;
  highlight?: boolean;
}

type DisplayListProps = {
  title?: string;
  items: ListItem[];
};

const getTextColor = (highlight: boolean | undefined, fallback: string) =>
  !!highlight ? 'text-indigo-600' : fallback;

export const DisplayList = ({ title, items }: DisplayListProps) => {
  const moreThanOneColumn = items.length > 6;
  const gridCols = moreThanOneColumn ? 'grid-cols-2' : 'grid-cols-1';
  const itemStyling = moreThanOneColumn
    ? 'grid-cols-1 lg:grid-cols-2'
    : 'grid-cols-2';

  return (
    <div className="w-full">
      {title && <SectionTitle title={title} />}
      <ul className={`grid ${gridCols} mt-2 px-4 gap-x-12`}>
        {items.map((item) => (
          <li
            key={item.name}
            className={`last:border-none border-b grid ${itemStyling} py-1`}
          >
            <p
              className={`font-semibold ${getTextColor(
                item.highlight,
                'text-gray-500'
              )}
                
              }`}
            >
              {item.name.toUpperCase()}:
            </p>
            <p
              className={`font-semibold text-end ${getTextColor(
                item.highlight,
                'text-black'
              )}`}
            >
              {item.value}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};
